import React from 'react';
import { connect } from 'react-redux';

import classes from './AddList.module.scss';

import Scroll from 'Flow2/components/UI/Container/Scroll';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';

import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';

import { FormattedMessage } from 'react-intl';

const MIN_INPUT_CHAR = 2;
const DEFAULT_VALUE_FIELD = "email";
const DEFAULT_LABEL_FIELD = "email";

const AddListRow = (props) => {
    let img = "";
    if (props.canRemove) {
        img = (<img alt="" className="pointer" onClick={props.remove} src={iconDelete} />);
    }

    return (<FlexRow className={[classes.Row, classes[props.canRemove]].join(' ')}>
        <span className={classes.RowData}>{props.label}</span>
        {img}
    </FlexRow>);
}

const AddListTab = props => {
    let img = props.canRemove ? <img alt="" className="pointer" onClick={props.remove} src={iconDelete} /> : "; ";

    return (
        <span className={[classes.Tab, classes[props.canRemove]].join(' ')}>
            <span title={props.label} className={classes.RowData}>{props.label}</span>
            {img}
        </span>
    );
}
/*
const AddListInput = (props) => {
    if (!props.showInput) {
        return "";
    }

    return (<FlexRow className={[classes.Input, 'relative'].join(' ')}>
        <Input
            value={props.value}
            elementConfig={{ type: 'text' }}
            changed={props.changed} />
        <img alt="" className={[classes.clear, 'pointer'].join(' ')} onClick={() => { props.clear() }} src={iconDelete} />
        <span className={[classes.open, classes[props.open]].join(' ')} onClick={() => { props.openHandler() }} />
    </FlexRow>);
}
*/
class AddList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            input: "",
            open: false,
            list: this.filterList(props),//props.list || props.users,
            valueField: props.valueField || DEFAULT_VALUE_FIELD,
            labelField: props.labelField || DEFAULT_LABEL_FIELD,
            intlField: props.intlField || "",
            data: props.data || [],
            showList: props.showList || true,
            showInput: props.add ? true : false,
            canRemove: props.remove ? true : false,
            minInput: props.minInput || MIN_INPUT_CHAR,
            hideUntilInput: props.hideUntilInput || false, // need for long lists
            limit: props.limit
        };
        
        this.elm = React.createRef();
        this.input = React.createRef();
    }

    onChangedHandler = (event) => {
        const input = event.target.value;
        let open = (input.length >= this.state.minInput);
        this.setState({ input: input, open: open });
    }

    onSelect = (value) => {
        this.elm.current && this.elm.current.classList.add(classes.clicked);
        this.props.add(value);
    }

    onRemoveClick = (index) => {
        this.elm.current && this.elm.current.classList.add(classes.clicked);
        this.props.remove(index);
    }

    onOpenClick = () => {
        this.setState({ open: !this.state.open });
    }

    onClearInput = () => {
        if(this.input.current) {
            this.input.current.value = "";
        }
        this.setState({ input: "", open: false });
    }

    createList = () => {
        if (!this.state.showList) {
            return "";
        }

        if (this.props.style === 'tab') {
            return this.createTabList();
        }

        return this.createRowList();
    }

    createTabList = () => {
        const rows = this.state.data.map((value, index) => {
            let label = value;

            // get label to display in list output
            this.state.list.forEach((item, index) => {
                if (item[this.state.valueField] == value) {
                    label = item[this.state.labelField];
                }
            });

            return (
                <AddListTab
                    key={value}
                    value={value}
                    label={label}
                    remove={() => this.onRemoveClick(index)}
                    canRemove={this.state.canRemove} />
            );
        });

        return (
            <FlexRow className={[classes.wrap, "AddListTabView"].join(' ')}>
                {rows}
            </FlexRow>
        );
    }

    createRowList = () => {
        const rows = this.state.data.map((value, index) => {
            let label = value;
			
            // get label to display in list output
            this.state.list.forEach((item, index) => {
                if (item[this.state.valueField] == value) {
                    label = item[this.state.labelField];
                }
            });

            return (
                <AddListRow
                    key={value}
                    value={value}
                    label={label}
                    remove={() => this.onRemoveClick(index)}
                    canRemove={this.state.canRemove} />
            );
        });

        return (
            <FlexColumn className={[classes.List, "AddListListView"].join(' ')}>
                {rows}
            </FlexColumn>
        );
    }
    
    showSuggestions = () => {
        return true;
        if(this.state.open && !this.state.hideUntilInput) return true;
        if(this.state.open && this.state.hideUntilInput && (this.state.input.length >= this.state.minInput)) return true;
        return false;
    }

    createSuggestions = () => {
        const list = [];
        if (this.showSuggestions()) {
            this.state.list.forEach((item, index) => {
                try {
                   if ((this.props.showAll || !this.itemAlreadyIncluded(item)) && item[this.state.labelField].toLowerCase().indexOf(this.state.input.toLowerCase()) !== -1) {
                        list.push(<span className="pointer" key={index} onClick={() => this.onSelect(item[this.state.valueField])}>{item[this.state.labelField]}</span>);
                    }
                } catch (err) {
                    console.log(err);
                }
            });
        }

        return (
            <Scroll className={[classes.Suggestions, classes[this.state.open]].join(' ')}>
                <FlexColumn className={""}>
                    {list}
                </FlexColumn>
            </Scroll>
        );
    }

    itemAlreadyIncluded = (item) => {
        return this.state.data.indexOf(item[this.state.valueField]+"") !== -1;
    }
    
    renderInput = () => {
        /*if (!this.state.showInput) {
            return "";
        }*/

        const cls = !this.state.showInput ? "hidden" : "";
        
        return (
            <FlexRow className={[classes.Input, 'relative', cls].join(' ')}>
                <input type={"text"} onChange={this.onChangedHandler} ref={this.input} />
                <img alt="" className={[classes.clear, 'pointer'].join(' ')} onClick={this.onClearInput} src={iconDelete} />
                <span className={[classes.open, classes[this.state.open]].join(' ')} onClick={this.onOpenClick} />
            </FlexRow>
        );
    }

    render = () => {
        /*const input = (
			<AddListInput
				showInput={this.state.showInput}
				value={this.state.input}
				changed={(event) => this.onChangedHandler(event)}
				clear={this.onClearInput}
				openHandler={this.onOpenClick}
				open={this.state.open} />
		);*/
        
        const input = this.renderInput();

        const list = this.createList();
        const suggestions = this.createSuggestions();

        return (
            <div ref={this.elm} className={[classes.AddList, "AddList"].join(' ')}>
                {(this.props.style === 'tab') ? "" : list}
                {input/*this.state.showInput && input /*this.renderInput()*/}
                {(this.props.style === 'tab') ? list : ""}
                <div className={classes.SuggestionsContainer}>
                    {suggestions}
                </div>
            </div>
        );
    }

    filterList = (props) => {
        let list = props.list || props.users;
        if (props.filter && props.filter.field && props.filter.values) {
            list = list.filter(item => {
                try {
                    const values = props.filter.values.split(';');
                    if (values.includes(item[props.filter.field])) {
                        return true;
                    }
                    return false;
                } catch (ex) {
                    return true;
                }
            });
        }
        return list;
    }
    
    setupListeners = () => {
        console.log(this.input,this.elm);
        if(this.input.current) {
            this.input.current.addEventListener("focus", (evt) => { 
                this.elm.current && this.elm.current.classList.add(classes.focused);
            });
            
            this.input.current.addEventListener("blur", (evt) => { 
                setTimeout(() => {
                    this.elm.current && this.elm.current.classList.remove(classes.focused);
                    if(this.elm.current && this.elm.current.classList.contains(classes.clicked)) {
                        this.elm.current.classList.remove(classes.clicked);
                        this.input.current && this.input.current.focus();
                    }
                }, 100);
            });
        }
    }
    
    componentDidMount() {
        this.setupListeners();
        /*console.log(this.input,this.elm);
        if(this.input.current) {
            this.input.current.addEventListener("focus", (evt) => { 
                this.elm.current && this.elm.current.classList.add(classes.focused);
            });
            
            this.input.current.addEventListener("blur", (evt) => { 
                setTimeout(() => {
                    this.elm.current && this.elm.current.classList.remove(classes.focused);
                    if(this.elm.current && this.elm.current.classList.contains(classes.clicked)) {
                        this.elm.current.classList.remove(classes.clicked);
                        this.input.current && this.input.current.focus();
                    }
                }, 100);
            });
        }*/
    }

    componentWillReceiveProps(nextProps) {
        let list = this.filterList(nextProps);
        console.log("componentWillReceiveProps");

        this.setState({
            input: nextProps.add ? this.state.input : "",
            list: list,//nextProps.list || nextProps.users,
            valueField: nextProps.valueField || DEFAULT_VALUE_FIELD,
            labelField: nextProps.labelField || DEFAULT_LABEL_FIELD,
            intlField: nextProps.intlField || "",
            data: nextProps.data || [],
            showList: nextProps.showList || true,
            showInput: (nextProps.add && true) || false,
            canRemove: (nextProps.remove && true) || false,
            minInput: nextProps.minInput || MIN_INPUT_CHAR,
            hideUntilInput: nextProps.hideUntilInput || false, // need for long lists
            open: (nextProps.add && this.state.open) || false
        });
    }

};

const mapStateToProps = (state, ownProps) => {
    return {
        users: state.user.users
    }
}

export default connect(mapStateToProps)(AddList);
